import { useState, useEffect } from "react";

/**
 * @deprecated Use `useBreakpoint()` from `src/utils/breakpoints.js` instead.
 *
 * ISP-4018 · Wave-6 responsive retrofit (00-RESPONSIVE-SYSTEM-and-REUSE-MAP §1.4).
 * This hook's bands DISAGREE with the canonical breakpoint system: it treats 768
 * as the "mobile" ceiling, whereas the retrofit system calls 600–899 tablet-
 * portrait (768 is a TABLET width, not a phone). Do NOT sed-replace call sites —
 * the correct replacement differs PER SITE:
 *
 *   OLD (useScreenSize)      MEANING                    NEW (breakpoints.js)      TRAP
 *   isMobile (<=768)         "phone OR tablet-ish"      isTabletP || isPhone      at 768: old=mobile,
 *                                                       (<=899) OR isPhone (<600)  new=tabletP. Sites gating
 *                                                       — decide per call site     TOUCH ui want <=899;
 *                                                                                  PHONE layout want <600.
 *   isTabletPortrait         tablet portrait            isTabletP (600–899)        band shrinks; 1024-portrait
 *     (769–1024 portrait)                                                          is now tabletL.
 *   isMobileLandscape        —                          isPhone && !isPortrait     most consumers mean
 *     (<=1024 landscape)                                 or isShort                "short viewport".
 *   isTablet (aspect 1.3–1.5) iPad guess                DELETE (aspect sniffing    replace with band+isTouch.
 *                                                        is unreliable)
 *
 * Kept working during migration; remove when its consumer count hits zero.
 */
function useScreenSize() {
  // Get initial screen dimensions
  const width = window.innerWidth;
  const height = window.innerHeight;

  // States to track different screen properties
  const [isMobile, setIsMobile] = useState(width <= 768);
  const [isPortrait, setIsPortrait] = useState(width < height);
  const [isMobilePortrait, setIsMobilePortrait] = useState(
    width <= 768 && width < height
  );
  const [isMobileLandscape, setIsMobileLandscape] = useState(
    width <= 1024 && width > height
  );
  const [isTabletPortrait, setIsTabletPortrait] = useState(
    width <= 1024 && width > 768 && width < height
  );
  const [portraitScreenRatio, setPortraitScreenRatio] = useState(
    height / width
  );
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const aspectRatio = width < height ? height / width : width / height;

      // Check if the device is a mobile based on width
      setIsMobile(width <= 768);

      // Check if the orientation is portrait
      setIsPortrait(width < height);

      // Check if the device is in mobile landscape mode
      setIsMobileLandscape(width <= 1024 && width > height);

      // Check if the device is in mobile portrait mode
      setIsMobilePortrait(width <= 768 && width < height);

      setIsTabletPortrait(width <= 1024  && width > 768 && width < height);

      // Update the portrait screen ratio
      setPortraitScreenRatio(height / width);

      // Check if the device is an iPad based on the aspect ratio within a range
      const isTabletAspectRatio = aspectRatio >= 1.3 && aspectRatio <= 1.5 ? true :false ;

      setIsTablet(isTabletAspectRatio);
    }

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Initial check in case the component mounts after the window has been resized
    handleResize();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    isMobile,
    isPortrait,
    isMobilePortrait,
    isMobileLandscape,
    isTabletPortrait,
    portraitScreenRatio,
    isTablet, // Return the new isTablet state
  };
}

export default useScreenSize;